import React, { useEffect, useRef } from "react";
import { hexToRgbForTailwindConfig, valueToPx } from "core/helpers";
import { Helmet } from "react-helmet-async";
import useForm from "modules/forms/hooks/useForm";

type Props = {
    children: React.ReactNode;
};

export default function HostedFormContainer(props: Props) {
    const { form } = useForm();
    const branding = form.branding;
    const headTag = useRef(document.getElementsByTagName('head')[0]);
    const styleTag = useRef(headTag.current.appendChild(document.createElement("style")));

    useEffect(() => {
        if (branding.font.type === "custom") {
            const googleFont = new FontFace(branding.font.family, `url(${branding.font.url})`);

            googleFont.load().then((loadedFont) => {
                document.fonts.add(loadedFont);
            }).catch((error) => {
                console.error('Failed to load Custom Font:', error);
            });
        }
    }, [branding.font]);

    useEffect(() => {
        styleTag.current.innerHTML = `
            :root {
                --fontFamily: ${branding.font.family};
                --textColor: ${hexToRgbForTailwindConfig(branding.text_color)};
                --backgroundColor: ${hexToRgbForTailwindConfig(branding.background_color)};
                --cardBackgroundColor: ${hexToRgbForTailwindConfig(branding.card_background_color)};
                --buttonTextColor: ${hexToRgbForTailwindConfig(branding.button_text_color)};
                --buttonBackgroundColor: ${hexToRgbForTailwindConfig(branding.button_background_color)};
            }
        `;
    }, [branding]);

    return (
        <div className={"font-custom-family"}>
            <Helmet>
                <title>{form.name}</title>
                <link rel={"icon"} type={"image/x-icon"} href={form.icon}/>
                <meta content={branding.background_color} name="theme-color"/>

                {branding.font.type === "google" && (
                    <link href={branding.font.url} rel="stylesheet"/>
                )}
            </Helmet>

            <div className={"min-h-screen bg-background px-3 pb-6 pt-3 md:w-full md:py-20"}>
                <div
                    className={"mx-auto rounded-xl bg-card p-3 shadow-md md:p-10"}
                    style={{
                        maxWidth: branding.width ? valueToPx(branding.width) : "600px",
                    }}
                >
                    {props.children}
                </div>
            </div>
        </div>
    );
}
